The details of a job ad preview.
